/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { SecCodeModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchSecCodesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchSecCodes
   * @name AchSecCodesGet
   * @summary Returns the available SEC Code from Core for ACH.
   * @request GET:/achSecCodes
   */
  achSecCodesGet = (params: RequestParams = {}) =>
    this.http.request<SecCodeModelDto[], any>({
      path: `/achSecCodes`,
      method: "GET",
      format: "json",
      ...params,
    });
}
